var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWater = function SvgWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m22.994 5.331 8.15 12.1.036.056c3.151 5.274 1.914 11.964-2.897 15.856-4.794 3.88-11.77 3.88-16.566 0C6.906 29.452 5.67 22.762 8.82 17.488q.017-.03.036-.057l8.155-12.1c.276-.41.636-.759 1.056-1.022l.001-.001c1.638-1.025 3.841-.592 4.927 1.024m-3.6 1.095c-.123.077-.23.18-.31.3l-8.136 12.072C8.469 22.98 9.436 28.283 13.29 31.4c3.878 3.137 9.544 3.137 13.42 0 3.854-3.117 4.82-8.42 2.34-12.602L20.92 6.726c-.315-.467-1.001-.628-1.526-.3",
    clipRule: "evenodd"
  })));
};
export default SvgWater;